import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import { TButtonSize, TButtonVariant } from './button.types';
import { buttonSize, overlayConfig } from './button.utils';

export const ButtonContentSC = styled.div<{ $loading?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  visibility: ${({ $loading }) => ($loading ? 'hidden' : 'visible')};
`;

export const ButtonSC = styled.button<{
  $variant: TButtonVariant;
  $size: TButtonSize;
  $block: boolean;
  $color: string;
  $backgroundColor: string;
}>`
  position: relative;
  background: none;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  &:not(:disabled) {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:hover {
    box-shadow: ${({ $variant, theme }) =>
      $variant === 'primary' ? `0px 0px 4px 2px ${rgba(theme.color.solid.selection, 0.5)};` : '0'};
  }

  .loader {
    position: absolute;
    inset: 0;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${({ theme, $size, $block, $color, $backgroundColor, $variant }) => {
    const config = buttonSize[$size];

    return css`
      color: ${$color};
      height: ${config.height}px;
      min-width: ${$block ? '100%' : `${config.minWidth}px`};

      &,
      .loader {
        background-color: ${$backgroundColor};
        border-radius: ${config.borderRadius}px;

        &:hover:not(:disabled) {
          background-color: ${theme.createOverlayColor(
            $backgroundColor,
            'hover',
            overlayConfig[$variant],
          )};
        }

        :active {
          opacity: 0.2;
        }

        :focus {
          background-color: ${theme.createOverlayColor(
            $backgroundColor,
            'focused',
            overlayConfig[$variant],
          )};
          border: none;
          outline: none;
        }
      }
    `;
  }};
`;

export const ButtonTextContentSC = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: center;
  flex-shrink: 1;
`;
